module.exports = __webpack_public_path__ + "static/media/sopt3ru.0290eb9d.pdf";